import { gql } from "graphql-request";
import { z } from "zod";
import { CommunityCreator, CommunityCreatorFragment } from "./communityCreator";
import { Image, ImageFragment } from "./image";
import { Sys, SysFragment } from "./sys";
import { Locale } from "../../locale";

export const CommunityLivestreamEntry = z.object({
  sys: Sys,

  livestreamCreator: CommunityCreator.nullable(),

  livestreamEntryTitle: z.string().nullable(),
  livestreamEntryVideoUrl: z.string().nullable(),
  livestreamEntryVideoLocale: Locale.nullable(),
  livestreamEntrySubmissionInfo: z.string().nullable(),
  livestreamEntryVideoThumbnail: Image.nullable(),
  livestreamEntryVideoThumbnailEn: Image.nullable(),
  livestreamEntryStartDate: z.string().nullable(),
  livestreamEntryEndDate: z.string().nullable(),
});

export type CommunityLivestreamEntry = z.infer<typeof CommunityLivestreamEntry>;

export const CommunityLivestreamEntryFragment = gql`
  fragment CommunityLivestreamEntryFragment on CommunityLivestreamEntry {
    sys {
      ...SysFragment
    }
    livestreamEntryTitle
    livestreamEntryVideoUrl
    livestreamEntryVideoLocale
    livestreamEntrySubmissionInfo
    livestreamEntryStartDate
    livestreamEntryEndDate
    livestreamEntryVideoThumbnail {
      ...ImageFragment
    }
    livestreamEntryVideoThumbnailEn: livestreamEntryVideoThumbnail(
      locale: "en"
    ) {
      ...ImageFragment
    }
    livestreamCreator {
      ...CommunityCreatorFragment
    }
  }

  ${CommunityCreatorFragment}
  ${ImageFragment}
  ${SysFragment}
`;
